import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {
    SimplePresentation,
    SimplePresentationRunner
} from "../../core/winpresentation/SimplePresentationRunner";
import {TheCrypt} from "../TheCrypt";
import {TheCryptGameMode} from "../server/TheCryptGameMode";
import {DropInPresentation} from "../presentations/maingame/DropInPresentation";
import {FillUpPresentation} from "../presentations/maingame/FillUpPresentation";

export class TheCryptNormalResultPresentation implements FlowStatePresentation {

    constructor() {    }

    public start(flowStateController:FlowStateController) {
        const presentations:SimplePresentation[] = [];
        if (TheCrypt.model.data.mode == TheCryptGameMode.NORMAL){
            //presentations.push(new LocalPresentation((controller:SimplePresentationRunnerController)=>this.checkLocksAndXBet(controller), ()=>true, "checkLocksAndXBet"));
            presentations.push(new DropInPresentation());
        } else if (TheCrypt.model.data.mode == TheCryptGameMode.NORMAL_AVALANCHE) {
            presentations.push(new FillUpPresentation());
        }

        SimplePresentationRunner.run(presentations, () => flowStateController.finish(), (callback?:Function) => flowStateController.setSkipCallback(callback));

    }
}